export * from './BookClosedIcon';
export * from './BookClosedIcon16Light';
export * from './BookClosedIcon16Regular';
export * from './BookClosedIcon16Solid';
export * from './BookClosedIcon20Light';
export * from './BookClosedIcon20Regular';
export * from './BookClosedIcon20Solid';
export * from './BookClosedIcon24Regular';
export * from './BookClosedIcon24Solid';
export * from './BookClosedIcon32Regular';
export * from './BookClosedIcon64Regular';
